import {
  FETCH_POST,
  FETCH_POST_SUCCESS,
  FETCH_POST_FAIL,
} from '../config/constant';

const initialState = {
  posts: [],
  fetchingPosts: false,
  error: false,
};

export default function dataReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_POST:
      return {
        ...state,
        posts: [],
        fetchingPosts: true,
      };
    case FETCH_POST_SUCCESS:
      return {
        ...state,
        fetchingPosts: false,
        posts: action.posts ?? [],
      };
    case FETCH_POST_FAIL:
      return {
        ...state,
        fetchingPosts: false,
        error: true,
      };
    default:
      return state;
  }
}
